export enum QuestionnairePageType {
  Question = 'Question',
  AddressValidation = 'AddressValidation',
  TimeSlots = 'TimeSlots',
  Complete = 'Complete',
  Support = 'Support',
  Error = 'Error'
}
